import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import _ from 'lodash'

var EditArticle = {
  data() {
    return {
      article: { data: {} },
      config: {},
      loading: false,
      fullScreenLoading: false,
      editor: ClassicEditor,
      editorConfig: {
        link: {
          addTargetToExternalLinks: true
        }
      },
      dropzoneOptions: {
        previewTemplate: '<div></div>',
      },
      errors: {}
    }
  },
  methods: {
    save() {
      if (!_.values(this.errors).every(_.isEmpty)) return;
      this.loading = true;
      if (this.article.id) {
        this.$article.updateArticle(this.article, this.afterUpdate, this.updateErrorHandler)
      } else {
        this.$article.createArticle(this.article, this.afterUpdate, this.updateErrorHandler)
      }
    },
    beforeOpen(event) {
      this.article = event.params.article
      this.config = event.params.config || {}
    },
    afterUpdate() {
      this.loading = false
      this.$emit('updated')
      this.$modal.hide('edit-city-page-modal')
      this.$modal.hide('edit-post-modal')
    },
    updateErrorHandler() {
      this.loading = false
      alert("Something went wrong, please try again!")
    },
    emitDestroy() {
      this.$emit('destroy', this.article)
    },
    s3UploadSuccess(location) {
      this.startHideProrgressBar()
      this.article.data.coverURL = location
    },
    updateProgress(file, progress) {
      file
      this.progress = progress
    },
    publishToProduction() {
      this.loading = true;
      this.$article.publishToProduction(this.article, this.afterUpdate, this.updateErrorHandler)
    }
  },
  computed: {
    awss3() {
      return {
        signingURL: process.env.VUE_APP_AUTH_API + '/s3_objects',
        sendFileToServer: false,
      }
    },
  }
}

export default EditArticle;
